import { render } from "./ReportAccident.vue?vue&type=template&id=5d4d141a&scoped=true"
import script from "./ReportAccident.vue?vue&type=script&lang=js"
export * from "./ReportAccident.vue?vue&type=script&lang=js"

import "./ReportAccident.vue?vue&type=style&index=0&id=5d4d141a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4d141a"]])

export default __exports__